/**
 * The shared password rule (legacy `validators.js:10`, wp/shell §5.5), which is also what the API enforces
 * ("Password does not meet requirements"): ≥ 8 characters, a lowercase, an uppercase, a digit and one of `. ~ % ^ ! @ # $ & * ( )`.
 */
export const PASSWORD_RULE = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.~%^!@#$&*()]).{8,}/

const SPECIAL = /[.~%^!@#$&*()]/

export interface PasswordChecks {
  length: boolean
  uppercase: boolean
  number: boolean
  special: boolean
}

/**
 * The four lines of the legacy checklist. The special-character line uses the rule's own set: legacy ticked it for any
 * punctuation (`_` included) while the rule refused the password (wp/shell §4.4) — the two now agree.
 */
export function passwordChecks(value: string | null | undefined): PasswordChecks {
  const text = value ?? ''
  return {
    length: text.length >= 8,
    uppercase: /[A-Z]/.test(text),
    number: /\d/.test(text),
    special: SPECIAL.test(text),
  }
}

export function isValidPassword(value: string | null | undefined): boolean {
  return PASSWORD_RULE.test(value ?? '')
}
